import { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { AiFillEdit } from 'react-icons/ai';
import { switchPaymentStatus, switchStatus } from '../../../actions';
import { useDispatch } from 'react-redux';


const CustomMenu = (props) => {
    const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (option) => {
    handleClose();
    if(option === 'asistencia'){
      dispatch(switchStatus(props.id))
    }
    if(option === "pago"){
      dispatch(switchPaymentStatus(props.id))
    }
    props.handleUpdateTurnos()
  }

  return (
    <div>
      <button onClick={handleClick}>
        <AiFillEdit />
      </button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleOptionClick('asistencia')}>Modificar Asistencia</MenuItem>
        <MenuItem onClick={() => handleOptionClick('pago')}>Modificar Pago</MenuItem>
      </Menu>
    </div>
  );
}
export default CustomMenu